<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
		</section>

		<section class="dp-right">
			<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
				<toolbar :buttonList="buttonList" @callFunction="callFunction" style="flex: 1; margin-bottom: 0;">
				</toolbar>
				<el-button type="danger" size="small" icon="el-icon-delete" @click="handleClearOverdue"
					style="margin-left: 10px;">一键清除超期</el-button>
			</div>
			<div class="all_page_border">
								<!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
								<div class="tbl-scroll-host">
								<el-table height="100%" :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange">

					<el-table-column type="selection"> </el-table-column>

					<el-table-column prop="Title" label="标题" width></el-table-column>

					<el-table-column prop="Url" label="外链地址" width>
						<template slot-scope="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.Url" placement="top">
								<a :href="scope.row.Url" target="_blank"
									style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle;"
									:title="scope.row.Url">
									{{ scope.row.Url }}
								</a>
							</el-tooltip>
						</template>
					</el-table-column>

					<el-table-column prop="IsChecked" label="是否审核" width>
						<template slot-scope="scope">
							<el-tag v-if="scope.row.IsChecked == 1 || scope.row.IsChecked === true" type="success" disable-transitions>是</el-tag>
							<el-tag v-else-if="hasPartialApproval(scope.row)" type="warning" disable-transitions>会签中</el-tag>
							<el-tag v-else type="info" disable-transitions>否</el-tag>
						</template>
					</el-table-column>
					<!-- 添加审核人列 -->
					<el-table-column prop="CheckedBy" label="审核人" width></el-table-column>

					<!-- 添加审核时间列 -->
					<el-table-column prop="CheckedTime" label="审核时间" :formatter="formatCheckedTime"
						width></el-table-column>

					<el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime"
						width></el-table-column>

					<!-- 操作列 - 超过15天未审批加入快捷删除 -->
					<el-table-column label="操作" width="175" fixed="right">
						<template slot-scope="scope">
							<el-button size="small" type="primary" @click="handleCheck(scope.row)"
								:disabled="scope.row.IsChecked == 1">
								{{ scope.row.IsChecked == 1 ? '已审核' : '审核' }}
							</el-button>
							<el-button v-if="scope.row.IsChecked != 1 && isOverdue(scope.row.CreateTime)" size="small"
								type="danger" @click="handleQuickDel(scope.row)">
								快捷删除
							</el-button>
						</template>
					</el-table-column>

				</el-table>
								</div>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>

		</section>

		<!-- 按条件清除超期临时新闻弹窗。最后更新：2026-09-30 -->
		<el-dialog custom-class="clear-overdue-dialog" :visible.sync="clearDialogVisible" width="440px"
			:close-on-click-modal="false" append-to-body>
			<div slot="title" class="clear-dlg-title">
				<span class="clear-dlg-title__icon"><i class="el-icon-delete"></i></span>
				<div class="clear-dlg-title__text">
					<div class="clear-dlg-title__main">清除超期新闻</div>
					<div class="clear-dlg-title__sub">{{ currentDepartmentName || '未选择学校' }}</div>
				</div>
			</div>
			<div class="clear-dlg-body">
				<div class="clear-dlg-hint">
					删除创建时间不晚于截止日的记录，默认截止日为 15 天前。
				</div>
				<el-form :model="clearForm" label-position="top" size="small" class="clear-dlg-form">
					<el-form-item label="创建截止日" required>
						<el-date-picker v-model="clearForm.beforeTime" type="date" placeholder="选择截止日"
							value-format="yyyy-MM-dd" style="width: 100%;" :clearable="false">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="清除范围">
						<div class="clear-dlg-switch"
							:class="{ 'is-on': clearForm.onlyUnchecked }"
							@click="clearForm.onlyUnchecked = !clearForm.onlyUnchecked">
							<span class="clear-dlg-switch__label">仅未审核</span>
							<span class="clear-dlg-switch__desc">{{ clearForm.onlyUnchecked ? '只清未审核' : '含已审核' }}</span>
							<i :class="clearForm.onlyUnchecked ? 'el-icon-check' : 'el-icon-close'"></i>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="clear-dlg-footer">
				<el-button @click="clearDialogVisible = false">取消</el-button>
				<el-button type="danger" @click="confirmClearOverdue" :loading="clearLoading">确认清除</el-button>
			</div>
		</el-dialog>

		<!-- 设置部门审批人：内部通讯录多选。最后更新：2026-09-30 -->
		<el-dialog :title="'设置部门审批人【' + currentDepartmentName + '】'" :visible.sync="approverDialogVisible" width="480px"
			:close-on-click-modal="false">
			<el-form label-width="110px">
				<el-form-item label="选择审批人" required>
					<div class="ps-pick-summary">
						<span v-if="approverSelectedItems.length">已选 <strong>{{ approverSelectedItems.length }}</strong> 人</span>
						<span v-else class="muted-text">请选择教职工</span>
						<el-button type="primary" size="small" plain @click="approverPickerVisible = true">选择教职工</el-button>
						<el-button v-if="approverSelectedItems.length" type="text" size="small"
							@click="clearApproverSelection">清空</el-button>
					</div>
					<div v-if="approverSelectedItems.length" class="ps-pick-tags">
						<el-tag v-for="item in approverSelectedPreview" :key="item.id" size="mini" closable
							disable-transitions @close="removeApproverSelected(item.id)">
							{{ item.name }}
						</el-tag>
						<span v-if="approverSelectedItems.length > 8" class="ps-pick-more">等 {{ approverSelectedItems.length }} 人</span>
					</div>
					<div class="form-tip">{{ approverAuditTip }}</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="approverDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmSetDepartmentApprover"
					:loading="settingLoading">确认设置</el-button>
			</div>
		</el-dialog>

		<person-scope-multi-picker-dialog
			:visible.sync="approverPickerVisible"
			directory-scope="internal"
			:show-scope-tabs="false"
			:scope-department-id="DepartmentId"
			title="选择审批人"
			:value="approverSelectedItems"
			@confirm="onApproversPicked"
		/>

	</section>

</template>

<script>
import util from '../../../util/date'
import { getTempNewsList, deleteTempNews, auditAndPublishTempNews, fetchSchoolNews, getAuditorsByDepartment, saveAuditor, countClearableTempNews, clearOverdueTempNews, getTempNewsAuditConfig } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopeMultiPickerDialog from '../../components/PersonScopeMultiPickerDialog'
export default {
	components: { Toolbar, DepartmentPane, PersonScopeMultiPickerDialog },
	data() {
		return {
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			imageUrl: '',
			imageLoadding: false,
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			DepartmentId: 0,
			multipleSelection: [],

			// 部门审批人：内部通讯录多选
			approverDialogVisible: false,
			approverPickerVisible: false,
			approverSelectedItems: [],
			approverRequireAll: false,
			settingLoading: false,
			currentDepartmentName: '', // 当前部门名称

			// 按条件清除超期
			clearDialogVisible: false,
			clearLoading: false,
			clearForm: {
				beforeTime: '',
				onlyUnchecked: true
			}
		}
	},
	computed: {
		approverSelectedPreview() {
			return (this.approverSelectedItems || []).slice(0, 8)
		},
		approverAuditTip() {
			if (this.approverRequireAll) {
				return '从内部通讯录选择，可多选。当前学校已开启全部同意（会签）：名单内所有人都需同意才发布。'
			}
			return '从内部通讯录选择，可多选。当前为任一人同意即可发布（可在学校配置改为全部同意）。'
		}
	},
	methods: {
		// 手动获取新闻：先确认再请求。最后更新：2026-09-30
		manualFetch() {
			if (this.DepartmentId == 0) {
				this.$message.info('请先选择部门...');
				return
			}

			this.$confirm('确认从央视新闻拉取最新资讯并写入待审核列表吗？', '提示', {
				type: 'warning'
			}).then(() => {
				this.listLoading = true;
				fetchSchoolNews({ schoolId: this.DepartmentId, force: true }).then((res) => {
					this.listLoading = false;
					if (util.isEmt.format(res)) {
						return;
					}

					if (res.data.success) {
						const count = Number(res.data.response) || 0
						this.$message({
							message: res.data.msg || (count > 0 ? `获取成功，新增 ${count} 条` : '暂无新增新闻'),
							type: count > 0 ? 'success' : 'info'
						});
						this.handleQuery();
					} else {
						this.$message({
							message: res.data.msg || '获取失败',
							type: 'error'
						});
					}
				}).catch(() => {
					this.listLoading = false;
					this.$message({
						message: '网络异常，刷新失败',
						type: 'error'
					});
				});
			}).catch(() => { })
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.currentDepartmentName = data.label || data.name || ''
			this.DepartmentId = data.value
			this.loadTempNewsAuditConfig(this.DepartmentId)
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		// 添加审核时间格式化方法
		formatCheckedTime: function (row, column) {
			return !row.CheckedTime || row.CheckedTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CheckedTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				departmentId: this.DepartmentId
			}
			getTempNewsList(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getTempNewsList(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.users = res.data.response.data
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})

				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteTempNews(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},

		// 审核操作：先拉真实会签配置再提示
		handleCheck(row) {
			const runConfirm = () => {
				const tip = this.approverRequireAll
					? '当前学校已开启全部同意（会签）。后台审核将直接终审通过并发布，确认继续吗？'
					: '确认审核此新闻并发布吗？'
				this.$confirm(tip, '提示', {
					type: 'warning',
				})
					.then(() => {
						this.listLoading = true

						const para = {
							Id: row.Id,
							IsChecked: 1,
						}

						auditAndPublishTempNews(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.listLoading = false
								return
							}
							this.listLoading = false
							if (res.data.success) {
								this.$message({
									message: res.data.msg || '审核成功',
									type: 'success',
								})
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg || '审核失败',
									type: 'error',
								})
							}
						})
					})
					.catch(() => { })
			}
			this.loadTempNewsAuditConfig(this.DepartmentId).then(runConfirm)
		},

		// 检查是否创建时间超过15天
		isOverdue(createTime) {
			if (!createTime) return false;
			const created = new Date(createTime).getTime();
			const now = new Date().getTime();
			const diffDays = (now - created) / (1000 * 60 * 60 * 24);
			return diffDays > 15;
		},

		// 是否已有部分会签记录
		hasPartialApproval(row) {
			if (!row || row.IsChecked == 1 || row.IsChecked === true) return false
			const ids = row.ApprovedAuditorIds || row.approvedAuditorIds || ''
			return String(ids).split(',').some((x) => x && x.trim())
		},

		// 行内快捷删除
		handleQuickDel(row) {
			this.$confirm('确认删除此条超期未审批的记录吗?', '提示', {
				type: 'warning',
			}).then(() => {
				this.listLoading = true;
				deleteTempNews({ ids: row.Id }).then((res) => {
					this.listLoading = false;
					if (res && res.data && res.data.success) {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.handleQuery();
					} else {
						this.$message({
							message: res ? res.data.msg : '删除失败',
							type: 'error'
						});
					}
				}).catch(() => {
					this.listLoading = false;
				});
			}).catch(() => { });
		},

		// 一键清除：打开按条件清除弹窗（默认截止日为 15 天前）
		handleClearOverdue() {
			if (!this.DepartmentId || this.DepartmentId == 0) {
				this.$message.info('请先选择部门...');
				return;
			}
			const d = new Date();
			d.setDate(d.getDate() - 15);
			const y = d.getFullYear();
			const m = String(d.getMonth() + 1).padStart(2, '0');
			const day = String(d.getDate()).padStart(2, '0');
			this.clearForm.beforeTime = `${y}-${m}-${day}`;
			this.clearForm.onlyUnchecked = true;
			this.clearDialogVisible = true;
		},

		// 确认按条件清除：先统计条数，再二次确认后删除
		confirmClearOverdue() {
			if (!this.clearForm.beforeTime) {
				this.$message.warning('请选择创建截止日');
				return;
			}
			this.clearLoading = true;
			const query = {
				departmentId: this.DepartmentId,
				beforeTime: this.clearForm.beforeTime,
				onlyUnchecked: this.clearForm.onlyUnchecked
			};
			countClearableTempNews(query).then((res) => {
				if (util.isEmt.format(res)) {
					this.clearLoading = false;
					return;
				}
				if (!res.data.success) {
					this.clearLoading = false;
					this.$message.error(res.data.msg || '统计失败');
					return;
				}
				const count = res.data.response || 0;
				if (count <= 0) {
					this.clearLoading = false;
					this.$message.info('没有符合条件的记录');
					return;
				}
				const scopeTip = this.clearForm.onlyUnchecked ? '未审核' : '全部审核状态';
				this.$confirm(
					`确认删除部门「${this.currentDepartmentName}」下，创建时间不晚于 ${this.clearForm.beforeTime} 的 ${count} 条${scopeTip}记录吗？`,
					'提示',
					{ type: 'warning' }
				).then(() => {
					clearOverdueTempNews({
						DepartmentId: this.DepartmentId,
						BeforeTime: this.clearForm.beforeTime,
						OnlyUnchecked: this.clearForm.onlyUnchecked
					}).then((delRes) => {
						this.clearLoading = false;
						if (delRes && delRes.data && delRes.data.success) {
							this.$message.success(delRes.data.msg || '一键清除成功');
							this.clearDialogVisible = false;
							this.handleQuery();
						} else {
							this.$message.error(delRes ? delRes.data.msg : '一键清除失败');
						}
					}).catch(() => {
						this.clearLoading = false;
						this.$message.error('网络异常，清除失败');
					});
				}).catch(() => {
					this.clearLoading = false;
				});
			}).catch(() => {
				this.clearLoading = false;
				this.$message.error('网络异常，统计失败');
			});
		},

		// 设置部门审批人按钮事件
		setApprovers() {
			if (this.DepartmentId == 0) {
				this.$message.info('请先选择部门...');
				return
			}
			this.approverSelectedItems = []
			this.approverDialogVisible = true
			this.loadTempNewsAuditConfig(this.DepartmentId)
			this.getDepartmentAuditors(this.DepartmentId)
		},

		// 加载学校会签配置
		loadTempNewsAuditConfig(departmentId) {
			if (!departmentId) {
				this.approverRequireAll = false
				return Promise.resolve(false)
			}
			return getTempNewsAuditConfig({ departmentId }).then((res) => {
				const data = res && res.data && res.data.response
				this.approverRequireAll = !!(data && (data.RequireAll === true || data.requireAll === true))
				return this.approverRequireAll
			}).catch(() => {
				this.approverRequireAll = false
				return false
			})
		},

		onApproversPicked(people) {
			this.approverSelectedItems = (people || []).map((p) => ({
				id: String(p.id),
				name: p.name || ('教职工#' + p.id),
				personType: 'teacher',
				deptId: p.deptId != null ? String(p.deptId) : '0',
				deptLabel: p.deptLabel || ''
			}))
		},

		clearApproverSelection() {
			this.approverSelectedItems = []
		},

		removeApproverSelected(id) {
			const key = String(id)
			this.approverSelectedItems = (this.approverSelectedItems || []).filter((x) => String(x.id) !== key)
		},

		// 根据部门ID获取审核人并回显
		getDepartmentAuditors(departmentId) {
			getAuditorsByDepartment({ departmentId: departmentId }).then((res) => {
				if (res.data && res.data.response) {
					this.approverSelectedItems = res.data.response.map((a) => ({
						id: String(a.AuditorId || a.auditorId),
						name: a.AuditorName || a.auditorName || ('教职工#' + (a.AuditorId || a.auditorId)),
						personType: 'teacher',
						deptId: String(this.DepartmentId || 0),
						deptLabel: this.currentDepartmentName || ''
					}))
				}
			})
		},

		// 确认设置部门审批人
		confirmSetDepartmentApprover() {
			const approverIds = (this.approverSelectedItems || [])
				.map((x) => x.id)
				.filter((id) => id)
				.join(',')
			const doSave = () => {
				this.settingLoading = true
				const para = {
					DepartmentId: this.DepartmentId,
					ApproverIds: approverIds
				}
				saveAuditor(para).then(res => {
					this.settingLoading = false;
					if (res.data && res.data.success) {
						this.$message.success('设置成功');
						this.approverDialogVisible = false;
					} else {
						this.$message.error(res.data.msg || '设置失败');
					}
				}).catch(() => {
					this.settingLoading = false;
					this.$message.error('网络异常，设置失败');
				});
			}
			if (!approverIds) {
				this.$confirm('当前未选择审批人，确认清空该校全部审批人吗？', '提示', { type: 'warning' })
					.then(doSave)
					.catch(() => { })
				return
			}
			doSave()
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.clear-dlg-title {
	display: flex;
	align-items: center;
	gap: 12px;
}

.clear-dlg-title__icon {
	width: 36px;
	height: 36px;
	border-radius: 10px;
	background: #fef2f2;
	color: #dc2626;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	flex-shrink: 0;
}

.clear-dlg-title__main {
	font-size: 16px;
	font-weight: 600;
	color: #0f172a;
	line-height: 1.3;
}

.clear-dlg-title__sub {
	margin-top: 2px;
	font-size: 12px;
	color: #64748b;
	line-height: 1.3;
}

.clear-dlg-body {
	padding: 2px 0 4px;
}

.clear-dlg-hint {
	margin-bottom: 16px;
	padding: 10px 12px;
	border-radius: 8px;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	color: #475569;
	font-size: 12px;
	line-height: 1.55;
}

.clear-dlg-form /deep/ .el-form-item {
	margin-bottom: 14px;
}

.clear-dlg-form /deep/ .el-form-item__label {
	padding: 0 0 6px;
	line-height: 1.2;
	color: #334155;
	font-weight: 500;
}

.clear-dlg-switch {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	padding: 10px 12px;
	border-radius: 8px;
	border: 1px solid #e2e8f0;
	background: #fff;
	cursor: pointer;
	transition: border-color 0.2s, background-color 0.2s;
	box-sizing: border-box;
}

.clear-dlg-switch:hover {
	border-color: #cbd5e1;
}

.clear-dlg-switch.is-on {
	border-color: #fecaca;
	background: #fff7f7;
}

.clear-dlg-switch__label {
	font-size: 13px;
	font-weight: 500;
	color: #0f172a;
}

.clear-dlg-switch__desc {
	flex: 1;
	font-size: 12px;
	color: #64748b;
	text-align: right;
}

.clear-dlg-switch > i {
	font-size: 14px;
	color: #94a3b8;
}

.clear-dlg-switch.is-on > i {
	color: #dc2626;
}

.clear-dlg-footer {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}

.ps-pick-summary {
	display: flex;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
	color: #475569;
	font-size: 13px;
}

.ps-pick-tags {
	margin-top: 8px;
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.ps-pick-more {
	color: #94a3b8;
	font-size: 12px;
	line-height: 24px;
}

.muted-text {
	color: #94a3b8;
}

.form-tip {
	color: #909399;
	font-size: 12px;
	line-height: 1.4;
	margin-top: 6px;
}
</style>

<style less>
/* append-to-body 弹窗外壳，需非 scoped */
.clear-overdue-dialog {
	border-radius: 12px;
	overflow: hidden;
}

.clear-overdue-dialog .el-dialog__header {
	padding: 18px 20px 12px;
	border-bottom: 1px solid #f1f5f9;
}

.clear-overdue-dialog .el-dialog__body {
	padding: 16px 20px 8px;
}

.clear-overdue-dialog .el-dialog__footer {
	padding: 12px 20px 18px;
	border-top: 1px solid #f1f5f9;
}

.clear-overdue-dialog .el-dialog__headerbtn {
	top: 18px;
	right: 18px;
}
</style>
